skrilla.controller('voidSelectionCtrl', function ($scope, searchService, modalService, cacheService) {
    $scope.bet = cacheService.getObjectOrElse("betDetails", function(){modalService.dismissAll()});
    $scope.selection = cacheService.getObjectOrElse("betSelection", function(){modalService.dismissAll()});
    $scope.void = cacheService.getObjectOrElse("voidSelection", function(){modalService.dismissAll()});
    $scope.getAction = function() {
      if ($scope.void) {
        return "void"
      } else {
        return "UNvoid"
      }
    }

    $scope.voidSelection = function(){
          searchService.put("bets/" + $scope.bet.id + "/selections/" + $scope.selection.id, {message: $scope.message, void: $scope.void},
            "Bet selection " + $scope.getAction() + " requested. This is a background process that may take some time to complete.").then(function(response){
              modalService.dismissAll();
          });
    }

});
